import OrderItemQuantityLimitStrategy from "@/domain/OrderItemQuantityLimitStrategy";

export const NoLimit = new OrderItemQuantityLimitStrategy(0, "Установлен в заказе")
export const SumLimit = new OrderItemQuantityLimitStrategy(1, "Суммарно не превышать заказ")
